angular.module('smartorg.r6.acts.image', []);
require('./image-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.image';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/image/app/js/plumbing/app.js